import { NgModule } from "@angular/core";
import { FilterPipe } from './filter.pipe'
import { YesNoPipe } from "./yesNo.pipe";
import { RecurrenceDayNamesPipe } from "./recurrence-days.pipe";
import { ExperimentDesignInstructionTypeNamePipe } from "./design-instruction-type.pipe";
import { ExperimentDesignInstructionSubtypeNamePipe } from "./design-instruction-subtype.pipe";

@NgModule({
    imports:[],
    declarations: [
        FilterPipe,
        YesNoPipe,
        RecurrenceDayNamesPipe,
        ExperimentDesignInstructionTypeNamePipe,
        ExperimentDesignInstructionSubtypeNamePipe
    ],
    exports:[
        FilterPipe,
        YesNoPipe,
        RecurrenceDayNamesPipe,
        ExperimentDesignInstructionTypeNamePipe,
        ExperimentDesignInstructionSubtypeNamePipe
    ]
})
export class ApplicationPipesModule {}



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/shared/pipes/application-pipes.module.ts